const IMAGES_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/integrity-program`

export type FlowStep = {
  id: number
  title: string
  description: string
  illustration: {
    src: string
    width: number
    height: number
  }
}

/**
 * Largura útil do card no desenho: 1343 menos os 50px de padding de cada lado.
 * As ilustrações abaixo têm as medidas do desenho e são posicionadas contra
 * essa largura, para manter a proporção interna do card em qualquer tela.
 */
export const DESIGN_PANEL_CONTENT_WIDTH = 1243

/** Fração da largura útil que o bloco de texto ocupa no desenho: 653 de 1243. */
export const DESIGN_TEXT_RATIO = 0.5253

/**
 * Títulos e descrições são os que já estavam em produção na seção de canal de
 * denúncias — o desenho novo usa exatamente os mesmos seis passos. Só as
 * ilustrações são novas.
 *
 * Cada ilustração tem tamanho próprio no desenho, e todas ficam encostadas na
 * borda direita da área útil. Antes o componente declarava 464x238 para todas,
 * que é a medida da etapa 2: a proporção saía errada nas outras cinco.
 */
export const flowSteps: FlowStep[] = [
  {
    id: 1,
    title: 'Abertura do relato',
    description:
      'O comunicante tem conhecimento de um descumprimento do Programa de Integridade da Cashme e utiliza um dos nossos canais. Pode se identificar ou se manter anônimo, e deve acompanhar pelo número de protocolo os próximos passos.',
    illustration: { src: `${IMAGES_PATH}/flow/etapa-1.svg`, width: 291, height: 238 }
  },
  {
    id: 2,
    title: 'Recebimento',
    description: 'Empresa terceirizada analisa o relato e envia para a CashMe.',
    illustration: { src: `${IMAGES_PATH}/flow/etapa-2.svg`, width: 464, height: 209 }
  },
  {
    id: 3,
    title: 'Investigação',
    description: 'Inicia-se a fase de investigação interna e sigilosa.',
    illustration: { src: `${IMAGES_PATH}/flow/etapa-3.svg`, width: 470, height: 201 }
  },
  {
    id: 4,
    title: 'Relatório final',
    description:
      'Apresentação do relatório de conclusão da investigação para o Comitê de Conduta Ética da CashMe.',
    illustration: { src: `${IMAGES_PATH}/flow/etapa-4.svg`, width: 434, height: 234 }
  },
  {
    id: 5,
    title: 'Tomada de decisão',
    description:
      'O Comitê de Conduta Ética decide sobre a aplicação de alguma medida descrita na Norma de Regras de Consequências da CashMe, de acordo com a apuração do caso e com a gravidade dos fatos.',
    illustration: { src: `${IMAGES_PATH}/flow/etapa-5.svg`, width: 450, height: 234 }
  },
  {
    id: 6,
    title: 'Encerramento do relato',
    description: 'Após apuração e definição de medidas, o caso é encerrado e documentado no sistema.',
    illustration: { src: `${IMAGES_PATH}/flow/etapa-6.svg`, width: 433, height: 153 }
  }
]
